import { useState } from 'react';

export const useStateObject = <T>(initialState: T) => {
  const [state, setState] = useState(initialState);
  const mergeState = (nextState: Partial<T>) =>
    setState({ ...state, ...nextState });
  return [state, mergeState] as [T, (nextState: Partial<T>) => void];
};
